<template>
    <div></div>
</template>

<script>
import { getInstance } from '@/auth/authWrapper'
import router from '@/router'

export default {
    name: 'home',
    async created() {
        // Get user info
        const authService = getInstance()
        await authService.getMe()
        const userRole = authService.getUserForPortalAccess().user_type

        // Redirect to corresponding home
        const home = userRole === 'admin' ? 'dashboard' : 'splash'
        const { href } = router.resolve({ name: home })

        window.location.href = href
    },
}
</script>
